import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeGetCompanyResponseDataSchema,
  DataResponseWithPagination,
  GetBackofficeCompanyParamsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeCompanyParamsSchema>
type Response = DataResponseWithPagination<z.infer<typeof BackofficeGetCompanyResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

export const getBackofficeCompanyQueryKey = (query: Query) => ["backofficeCompany", query]

type Props = {
  query: Query
  onSuccess?: OnSuccessFn
}

export const getBackofficeCompanyQuery = ({ query, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getBackofficeCompanyQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/backoffice/companies/${query.id}`)
      onSuccess?.(data)
      return data.data
    },
  })
}
